import { getAssert, getElse } from "../../utils/Safe";
import FlumpTextureSymbol from "./FlumpTextureSymbol";

/**
 * TODO - Add description.
 */
export default class FlumpAtlasSymbol
{
    /**
     * @param {Phaser.Game} game - A reference to the currently running game.
     * @param {*} atlasData - JSON object for the atlas.
     * @param {string} baseDir - Base directory of flump atlases.
     */
    constructor(game, atlasData, baseDir)
    {
        // Safely get these properties from the atlas data.
        let file = getAssert([atlasData, "file"], "[FlumpAtlasSymbol] Cannot find file in atlas data.");
        let textureList = getAssert([atlasData, "textures"], "[FlumpAtlasSymbol] Cannot find textures in atlas data.");
        let textureCount = getElse([textureList, "length"], 0);

        /** @type {Phaser.Image} */
        this.atlas = game.cache.getImage(baseDir+atlasData.file);        

        /** @type {string[]} */
        this.textureMap = new Array(textureCount);
        /** @type {FlumpTextureSymbol[]} */
        this.textures = {};
        
        // Create the texture symbols.
        for (var i = 0; i < textureCount; i++) 
        {
            this.textureMap[i] = textureList[i].symbol;
            this.textures[this.textureMap[i]] = new FlumpTextureSymbol(game, this.atlas, textureList[i]);
        }
    }
    
    /**
     * Cleans up the FlumpAtlasSymbol.
     */
    destroy()
    {
        this.atlas = null;
        
        if (this.textureMap != null)
        {
            while (this.textureMap.length > 0)
            {
                if (this.textures != null && this.textures.hasOwnProperty(this.textureMap[0]))
                {
                    this.textures[this.textureMap[0]].destroy();
                    delete this.textures[this.textureMap[0]];
                }
                this.textureMap.shift();
            }
            
            this.textureMap = null;
            this.textures = null;
        }

        this.game = null;
    }
}